import $ from "jquery";
import PropTypes from "prop-types";
import React from "react";

/**
 * Render a checkbox input as an on/off switch.
 *
 * @example
 *   <Switch
 *     defaultChecked={true}
 *     id="company_scheduled_statuses"
 *     name="company[scheduled_statuses]"
 *     offText="Off"
 *     onText="On"
 *   />
 */
class Switch extends React.Component {
  /**
   * Initializes the Bootstrap switch once the input is available.
   */
  componentDidMount() {
    const input = $(this.refs.input);

    input.bootstrapSwitch({
      offColor: "danger",
      offText: this.props.offText,
      onColor: "success",
      onText: this.props.onText,
      size: "small"
    });

    // The Bootstrap switch doesn't fire the input's onChange event, so we have to handle it separately.
    if (this.props.onChange != null) {
      input.on("switchChange.bootstrapSwitch", this.props.onChange);
    }
  }

  /**
   * Renders the checkbox tied to the Bootstrap switch.
   *
   * @returns {object} The React element
   */
  render() {
    // Collect the props that should be passed into the <input> component.
    const inputProps = { ...this.props };
    delete inputProps.offText;
    delete inputProps.onText;

    return (
      <span>
        <input name={inputProps.name} type="hidden" value="0" />
        <input {...inputProps} ref="input" type="checkbox" value="1" />
      </span>
    );
  }
}

Switch.propTypes = {
  offText: PropTypes.string.isRequired,
  onText: PropTypes.string.isRequired
};

export default Switch;
